import Cookies from 'js-cookie'

const app = {
  state: {
    routePath: {
      path: localStorage.getItem('routerPath')
    },
  },
  mutations: {
    TOGGLE_PATH: state => {
      if (state.routePath.path) 
      {
        localStorage.setItem('path',state.routePath.path)
      }
      else {
        localStorage.setItem('path', '/weekly')
      }
    },
  },
  actions: {
    TOGGLE_PATH({ commit }) 
    {
      commit('TOGGLE_PATH')
    },
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js